import { Exclude, Expose, Type } from 'class-transformer';
import { makeObservable, observable } from 'mobx';
import { eventTargetPlatforms } from '../../../../../architecture/constants/EventTrigger';
import {
  EventTargetPlatforms,
  EventTargetReceiverTypes,
} from '../../../../../architecture/enums/EventTrigger';
import { BaseEventReceiver, ISerializedEventReceiver } from '../BaseEventReceiver';
import { EventTarget, ISerializedEventTarget } from '../EventTarget';
import { GroupReceiver } from './Receivers/GroupReceiver';
import { UserReceiver } from './Receivers/UserReceiver';

const EVENT_RECEIVER_DISCRIMINATOR = {
  discriminator: {
    property: 'type',
    subTypes: [
      { value: GroupReceiver, name: EventTargetReceiverTypes.Group },
      { value: UserReceiver, name: EventTargetReceiverTypes.User },
    ],
  },
};

export class TelegramEventTarget extends EventTarget {
  platform = EventTargetPlatforms.Telegram;
  platformKey = eventTargetPlatforms.TELEGRAM;

  @Exclude()
  supportedReceivers = [
    EventTargetReceiverTypes['User'],
    EventTargetReceiverTypes['Group'],
  ];

  @Expose()
  @Type(() => BaseEventReceiver, EVENT_RECEIVER_DISCRIMINATOR)
  receiver: BaseEventReceiver;

  constructor() {
    super();

    makeObservable(this, {
      receiver: observable,
    });

    this.receiver = new UserReceiver();
  }

  get isValid(): boolean {
    return this.receiver.isValid;
  }

  get isChanged(): boolean {
    return this.receiver.isChanged;
  }

  serialize(): ISerializedTelegramEventTarget {
    return {
      ...super.serialize(),
      receiver: this.receiver.serialize(),
    };
  }
}

export interface ISerializedTelegramEventTarget extends ISerializedEventTarget {
  receiver: ISerializedEventReceiver;
}
